import { render, staticRenderFns } from "./CompanyProfile4.vue?vue&type=template&id=73872e1e&scoped=true&"
import script from "./CompanyProfile4.vue?vue&type=script&lang=js&"
export * from "./CompanyProfile4.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfile4.vue?vue&type=style&index=0&id=73872e1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73872e1e",
  null
  
)

export default component.exports